module.exports = __webpack_public_path__ + "img/loginImage.0d7e9213.png";